import { render, staticRenderFns } from "./AttendOrAbsentSuccessDlg.vue?vue&type=template&id=5488edf1&scoped=true&"
import script from "./AttendOrAbsentSuccessDlg.vue?vue&type=script&lang=js&"
export * from "./AttendOrAbsentSuccessDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488edf1",
  null
  
)

export default component.exports